"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateRolling24HrPxChangeValue = void 0;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var calculateRolling24HrPxChangeValue = exports.calculateRolling24HrPxChangeValue = function calculateRolling24HrPxChangeValue(price, change) {
  // rolling24HrPxChangeValue = LastTradedPx*(Rolling24HrPxChange(%)/(1 + Rolling24HrPxChange(%)))
  price = new _bignumber["default"](price);
  change = new _bignumber["default"](change / 100);
  return price.times(change.div(change.plus(1)));
};